import React, { useEffect } from "react";
import { useState } from "react";
import "./Playgame-new.css";
import RewardCard from "../../component/Cards/Reward";
import RoomCard from "../../component/Cards/RoomCard";
import { useNavigate, useParams } from "react-router-dom";
import OnevsOne from "../../component/1vs1journey/Onevsone";
import Addbuddy from "../../component/1vs1journey/Addbuddy";
import { GetGameDetails } from "../../GameServices/GameServices";
import CustomBetPopUp from "../../component/1vs1journey/CustomBetPopUp";
import { motion } from "framer-motion";
import { LazyMotion, domAnimation } from "framer-motion";
import JoinRoom from "../../component/1vs1journey/JoinRoom";
import PaymentPopUp from "./PaymentPopup/PaymentPopUp";
import { useAuthContext } from "../../AuthContext";
import "../../new-app.css";
import CustomChallenges from "../../component/CustomChallenges";

function Playgame() {
  const { isAuthenticated } = useAuthContext();

  useEffect(() => {
    const classExists = document.querySelector(".classonbody") !== null;
    if (!classExists) return;
    document.body.classList.add("body-class");
    return () => {
      document.body.classList.remove("body-class");
    };
  }, []);

  const props = useParams();
  const navigate = useNavigate();
  const [GameData, setGameData] = useState([]);
  const [paymentPopUp, setPaymentPopup] = useState(false);
  const [glory, setGlory] = useState();
  useEffect(() => {
    FetchGames();
  }, [props.id]);
  const FetchGames = async () => {
    console.log("props", props.id);
    let { data } = await GetGameDetails(props.id);
    setGameData(data);
  };
  function randomIntFromInterval(min, max) {
    // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  useEffect(() => {
    const Interval = setInterval(() => {
      setGlory(randomIntFromInterval(0, 9));
    }, 2000);
    return () => {
      clearInterval(Interval);
    };
  }, []);
  const practiceGame = (id, type, game) => {
    navigate(`/match`, {
      state: {
        id,
        type: type,
        value: 0,
        name: GameData?.name,
        gameBuild: GameData?.gameBuild,
        gameClass: GameData?.gameClass,
        practice: true,
      },
    });
  };

  function gameChanger(id, type, value, game) {
    if (!isAuthenticated) {
      setPaymentPopup(true);
    } else {
      navigate(`/match`, {
        state: {
          id,
          type: type,
          value: value,
          name: GameData?.name,
          gameBuild: GameData?.gameBuild,
          gameClass: GameData?.gameClass,
          gameType: "OneVSOne",
          direct: false,
          code: "",
        },
      });
    }
  }

  const handlePropGameChange = (params) => {
    navigate(`/match`, {
      state: {
        id: params.id,
        type: params.type,
        value: parseInt(params.value),
        name: GameData?.name,
        gameBuild: GameData?.gameBuild,
        gameClass: GameData?.gameClass,
        isCustomBet: true,
        gameType: "OneVSOne",
        direct: false,
        code: "",
      },
    });
  };
  const playGameHandler = (gameName) => {
    navigate(`/playgame/${gameName}`);
  };
  return (
    <div className="main-game-stage">
      <LazyMotion features={domAnimation}>
        <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }}>
          {/* <Header /> */}

          <section className="playgame-screen classonbody">
            <section className="playgame-sec">
              <div className="container-1280">
                <div className="row">
                  <div className="col-lg-6 logo">
                    <img src={require("../../Assets/img/diamond.png")} alt="battle" />
                    <h1>
                      Play <span>1 vs 1</span>
                    </h1>
                  </div>
                  <div className="col-lg-6">
                    <h2>STAGES</h2>
                  </div>
                </div>
              </div>
            </section>
            <section className="games-sec">
              <div className="container-1280">
                <div className="row justify-content-between">
                  <RewardCard
                    glow={glory === 1 ? true : false}
                    rating={1.8}
                    price="01"
                    play={() =>
                      gameChanger(
                        0,
                        GameData.stages ? GameData.stages[0].stage : 1,
                        // Moralis.Units.ETH(GameData?.stages[0].price),
                        GameData?.stages[0].price /* game price to be converted to ETH later */,
                        GameData?.name
                      )
                    }
                  />
                  <RewardCard
                    glow={glory === 2 ? true : false}
                    rating="09"
                    price="05"
                    play={() =>
                      gameChanger(
                        1,
                        GameData.stages ? GameData.stages[1].stage : 2,
                        // Moralis.Units.ETH(GameData?.stages[1].price),
                        GameData?.stages[1].price /* game price to be converted to ETH later */,
                        GameData?.name
                      )
                    }
                  />
                  <RewardCard
                    glow={glory === 3 ? true : false}
                    rating={18}
                    price="10"
                    play={() =>
                      gameChanger(
                        2,
                        GameData.stages ? GameData.stages[2].stage : 2,
                        // Moralis.Units.ETH(GameData?.stages[2].price),
                        GameData?.stages[2].price /* game price to be converted to ETH later */,
                        GameData?.name
                      )
                    }
                  />
                  <RewardCard
                    glow={glory === 4 ? true : false}
                    rating={90}
                    price="50"
                    play={() =>
                      gameChanger(
                        3,
                        GameData.stages ? GameData.stages[3].stage : 3,
                        // Moralis.Units.ETH(GameData?.stages[3].price),
                        GameData?.stages[3].price /* game price to be converted to ETH later */,
                        GameData?.name
                      )
                    }
                  />
                  <div className="col-lg-2 lg-img-box">
                    <div className="">
                      <img src={require("../../Assets/img/person.png")} alt="person" />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="play-friends">
              <div className="container-1280">
                <div className="row justify-content-between">
                  <div className="col-lg-2">
                    <h1>More Options</h1>
                    <h3>
                      Play With
                      <span> Friends</span>
                    </h3>
                    <img src={require("../../Assets/img/cup.png")} alt="cup" />
                  </div>
                  <RoomCard
                    glow={glory === 5 ? true : false}
                    title="Create & Play Custom Room"
                    subtitle="Lets Create"
                    img={require("../../Assets/img/kids.png")}
                    name="LUDO"
                    isAuthenticated={isAuthenticated}
                    paymentPopUp={(value) => setPaymentPopup(value)}
                  />
                  <RoomCard
                    glow={glory === 6 ? true : false}
                    title="Join A Room"
                    subtitle="Join Now"
                    img={require("../../Assets/img/gameroom.png")}
                    name="JOIN_ROOM"
                    isAuthenticated={isAuthenticated}
                    paymentPopUp={(value) => setPaymentPopup(value)}
                  />
                  <RoomCard
                    glow={glory === 7 ? true : false}
                    title="Free Game Play"
                    subtitle="Play for free"
                    img={require("../../Assets/img/console.png")}
                    play={() => practiceGame(0, GameData?.stages[0].stage, GameData.name)}
                  />
                  <RoomCard
                    glow={glory === 8 ? true : false}
                    title="Play Tournament & Earn Big"
                    img={require("../../Assets/img/trophy.png")}
                  />

                  <div className="col-lg-2 check-games ">
                    <h4>
                      More <span>Games</span>
                    </h4>
                    <div className="images">
                      <img
                        src={require("../../Assets/img/gaming4.png")}
                        className="img-1"
                        alt="gaming"
                        onClick={() => {
                          playGameHandler("tetris");
                        }}
                      />
                    </div>
                    <div className="images">
                      <img
                        src={require("../../Assets/img/gaming2.png")}
                        className="img-2"
                        alt="gaming"
                        onClick={() => {
                          playGameHandler("2048");
                        }}
                      />
                    </div>
                    <div className="images">
                      <img
                        src={require("../../Assets/img/game-2.jpg")}
                        className="img-3"
                        alt="gaming"
                        onClick={() => {
                          playGameHandler("stack");
                        }}
                      />
                    </div>
                    <div className="images">
                      <img
                        src={require("../../Assets/img/game5.png")}
                        className="img-4"
                        alt="gaming"
                        onClick={() => {
                          playGameHandler("road");
                        }}
                      />
                    </div>
                    <div className="images">
                      <img src={require("../../Assets/img/gaming4.png")} className="img-5" alt="gaming" />
                    </div>
                    <div className="images">
                      <img src={require("../../Assets/img/gaming4.png")} className="img-6" alt="gaming" />
                    </div>
                    <div className="images">
                      <img src={require("../../Assets/img/gaming3.png")} className="img-7" alt="gaming" />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <section className="challenges">
              <div className="container-1280">
                <div className="row">
                  <div className="col-lg-2 px-0">
                    <h1>
                      Open <span>Challenges</span>
                    </h1>
                  </div>
                  <div className="col-lg-10">
                    <CustomChallenges
                      glow={glory === 9 ? true : false}
                      id={props?.id}
                      isAuthenticated={isAuthenticated}
                      popup={(value) => setPaymentPopup(value)}
                    />
                  </div>
                </div>
              </div>
            </section>
          </section>
          <section className="absolute-sm-imgs">
            <div className="asi-1">
              <img
                src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
                alt=""
              />
            </div>
            <div className="asi-2">
              <img
                src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
                alt=""
              />
            </div>
            <div className="asi-3">
              <img
                src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
                alt=""
              />
            </div>
            <div className="asi-4">
              <img
                src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
                alt=""
              />
            </div>
            <div className="asi-5">
              <img
                src={`https://storage.googleapis.com/ga-site-assets/Assets/game-bg-icon/${props.id ? props.id : "null-image"}.png`}
                alt=""
              />
            </div>
          </section>
          <OnevsOne gameImage={GameData} />
          <JoinRoom gameImage={GameData} />
          {/* <CustomBetPopUp
            gameImage={GameData}
            betHandler={(data) => {
              handlePropGameChange(data);
            }}
          /> */}
          <Addbuddy play={() => practiceGame(0, GameData?.stages[0]?.stage, GameData?.name)} />
          <PaymentPopUp
            show={paymentPopUp}
            closeModal={() => setPaymentPopup(false)}
            playPractice={() => practiceGame(0, GameData?.stages[0].stage, GameData.name)}
          />
        </motion.div>
      </LazyMotion>
    </div>
  );
}
export default Playgame;
